import { array as codecArray } from 'purify-ts/Codec';
import { makeResponses } from '../response_factory';
import { utils as coreUtils, paginated, requestParams } from '@codegrade/api-core';
import { PatchRoleData, RoleAsJSONWithPerms } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
const makeResult = coreUtils.makeResult;
// eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function role(config) {
    const getAllResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ paginated.makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(RoleAsJSONWithPerms))),
    });
    const patchResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    return Object.freeze({
        /**
         * Get all global roles with their permissions
         *
         * @param arg The arguments to the function.
         * @param arg.pageSize The size of a single page, maximum is 50.
         * @param arg.nextToken The next token, to retrieve a next page.
         * @returns An array of all global roles.
         */
        getAll: async ({ pageSize = undefined, nextToken = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/roles/`, getAllResponse.v, undefined, {
                'page-size': pageSize,
                'next-token': nextToken,
            });
            return result;
        },
        /**
         * Update the `Permission` of a given `Role`.
         *
         * @param arg The arguments to the function.
         * @param arg.roleId The id of the global role.
         * @param arg.requestBody The body of the request.
         * @returns An empty response with return code 204.
         */
        patch: async ({ roleId, requestBody, }) => {
            const result = await requestParams(config, 'PATCH', `/api/v1/roles/${roleId}`, patchResponse.v, JSON.stringify(PatchRoleData.encode(requestBody)));
            return result;
        },
    });
}
